module.exports = __webpack_public_path__ + "img/logo.ee9edce3.png";